var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRebrandAppIconKry(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1024,
    height: 1024,
    viewBox: "0 0 1024 1024",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1024,
    height: 1024,
    rx: 230,
    fill: "#73F8D0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M415.004 618.818L355.576 484.46L394.358 447.234C405.828 436.224 415.921 430.546 434.731 427.335V422.001H345.728V427.335C368.208 431.922 372.796 442.646 357.656 457.327L283.333 528.585V336.668H278.287L198 363.335V368.668C200.753 370.044 208.667 376.123 208.667 391.263V619.277C208.667 632.123 204.882 640.955 198 646.001V651.335H294V646.001C287.118 640.955 283.333 632.123 283.333 619.277V553.802L302.348 535.551L342.975 629.37C345.269 634.417 347.792 642.159 347.333 651.335H437.943V645.887C426.014 638.546 422.803 636.711 415.004 618.818Z",
    fill: "#1B4349"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M811.849 422V427.333C835.706 431.921 842.129 443.563 832.494 465.584L788.422 565.023L742.573 461.455C735.233 444.022 737.985 431.921 751.29 427.333V422H640.666V427.333C650.301 431.921 657.24 442.186 661.828 452.738L750.354 651.923C741.782 669.5 733.272 678 721.928 678C699.907 678 693.942 645.885 664.122 645.885C645.312 645.885 630.172 658.272 630.172 677.541C630.172 699.104 649.441 720.667 682.014 720.667C711.376 720.667 746.702 702.774 766.889 657.814L857.727 454.573C865.068 438.516 872.867 429.168 880.666 427.333V422H811.849Z",
    fill: "#1B4349"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M595.763 416.496C568.237 416.496 550.803 437.6 539.333 470.173V416.668H534L454 443.335V448.84C456.753 450.217 464.552 456.41 464.552 471.55V619.277C464.552 632.123 460.882 640.84 454 645.887V651.335H552.638V645.887C543.921 640.84 539.333 632.123 539.333 619.277V518.346C539.333 484.396 551.262 464.668 565.025 464.668C581.541 464.668 587.505 491.736 604.939 491.736C618.244 491.736 635.219 476.138 635.219 453.657C635.219 432.553 620.079 416.496 595.763 416.496Z",
    fill: "#1B4349"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRebrandAppIconKry);
export default __webpack_public_path__ + "static/media/rebrand-app-icon-kry.d6a0dfd2e1ca7d4fbb7dec794dcb7d77.svg";
export { ForwardRef as ReactComponent };